import { FtbComponentInput } from '@/types/schema';

export const getAdaptedContent = (content?: any[]) => {
  const adaptedContent: FtbComponentInput[] = [];

  let questionTextWithBlank = '';

  content?.forEach((inlineBlock) => {
    if (inlineBlock.type === 'blank') {
      adaptedContent.push({
        isBlank: true,
        text: inlineBlock.attrs.text,
      });
      questionTextWithBlank += ' _____ ';
    } else {
      adaptedContent.push({
        isBlank: false,
        text: inlineBlock.text,
      });
      questionTextWithBlank += inlineBlock.text;
    }
  });

  return { adaptedContent, questionTextWithBlank };
};

export const getContentJSON = (ftbComponents?: FtbComponentInput[]) => {
  const outputJSON: any = {
    type: 'doc',
    content: [
      {
        type: 'paragraph',
        content: [],
      },
    ],
  };
  ftbComponents?.forEach((block) => {
    block.isBlank
      ? outputJSON.content[0].content.push({
          type: 'blank',
          attrs: {
            text: block.text,
          },
        })
      : outputJSON.content[0].content.push({
          type: 'text',
          text: block.text,
        });
  });

  return outputJSON;
};
